import type { Address } from '../../types';

import useData from '@blueshift-ui/fetch/dist/hooks/use-data';

interface UseAdressParams {
  clientUuid: string;
}

function useAddress({ clientUuid }: UseAdressParams) {
  return useData<Address>({
    queryKey: ['client', clientUuid],
    queryOptions: {
      select(response: any) {
        if (!response) {
          return {};
        }

        const { address } = response;

        return address;
      },
    },
    request: {
      url: `/vtwa/v5/clients/${clientUuid}`,
    },
  });
}

export default useAddress;
